import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { Link } from "gatsby";
import ReactMarkdown from "react-markdown";
import ShareButtons from "../../share-buttons/sharebuttons.component";

const StoryComponent = ({ article, url }) => {

  const tagCloud = _generateTags(article);
  
  function _generateTags(articleData) {
    let tagArray = [];
    if (articleData.customTags && articleData.customTags.length > 0) {
      articleData.customTags.forEach(function (tag) {
        tagArray.push(tag);
      });
    }
    if (articleData.articleCategory) {
      tagArray.push(articleData.articleCategory);
    }
    if (articleData.categoryTag && articleData.categoryTag.length > 0) {
      articleData.categoryTag.forEach(function (tag) {
        tagArray.push(tag);
      });
    }
    if (articleData.subCategoryTags && articleData.subCategoryTags.length > 0) {
      articleData.subCategoryTags.forEach(function (tag) {
        tagArray.push(tag);
      });
    }
    if (articleData.productTags && articleData.productTags.length > 0) {
      articleData.productTags.forEach(function (tag) {
        tagArray.push(tag);
      });
    }
    return tagArray;
  }

  return (
    <Card
      sx={{
        borderRadius: 5,
        boxShadow: 1,
        mr: { xs: 0, sm: 0, md: 5 },
        ml: { xs: 0, sm: 0, md: 5 },
      }}
    >
      {article.youtubeEmbedURL ? (
        <>
          <CardMedia sx={{ height: 360 }}>
            <iframe
              width="100%"
              height="360px"
              src={article.youtubeEmbedURL}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              data-testid="youtube-iframe"
              style={{ marginBottom: 0 }}
            />
          </CardMedia>
        </>
      ) : (
        ""
      )}
      {article.featuredImage && article.youtubeEmbedURL === null ? (
        <>
          <CardMedia>
            <img
              src={article.featuredImage.localFile.url}
              alt={article.featuredImageAltText}
              placeholder="blurred"
              data-testid="card-img"
            />
          </CardMedia>
        </>
      ) : (
        ""
      )}
      <CardContent sx={{ pl: 4, pr: 4, pt: 3 }}>
        <ReactMarkdown linkTarget="_blank">
          {article.body && article.body.data ? article.body.data.body : ""}
        </ReactMarkdown>
      </CardContent>
      <Divider sx={{ ml: 4, mr: 4 }} />
      <CardContent sx={{ p: 4 }}>
        <Grid container direction="row" rowSpacing={2}>
          <Grid container item xs={12} lg={7} columnGap={1} direction="row">
            <Grid
              container
              item
              xs={"auto"}
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="h5" sx={{ color: "#68768B" }}>
                Tags
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={12}
              lg={5}
              spacing={0.5}
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              {tagCloud.map((tag) => (
                <Grid item xs={"auto"}>
                  <Link to={tag.path} style={{ textDecoration: "none" }}>
                    <Chip
                      size="small"
                      sx={{
                        fontSize: ".6rem",
                        fontWeight: 500,
                        borderRadius: 2,
                        color: "#718096",
                        backgroundColor: "#e2e8f0",
                      }}
                      label={tag.name}
                    />
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid container item xs={5} columnGap={1} direction="row">
            <Grid
              container
              item
              xs={"auto"}
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Grid item>
                <Typography variant="h5" sx={{ color: "#68768B" }}>
                  Share
                </Typography>
              </Grid>
              <Grid item>
                <ShareButtons
                  title={`Read ${article.title} `}
                  url={url}
                  twitterHandle={"LawNext"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default StoryComponent;
